import types from '../actionTypes';

export const addImageRequest = payload => ({
    type: types.ADD_IMAGE_REQUEST,
    payload,
});
